// extracted by mini-css-extract-plugin
export default {"meals":"AvalilableMeals_meals__ek7Hr","meals-appear":"AvalilableMeals_meals-appear__9mTyC"};